import gql from 'graphql-tag';

const orderNewCard = gql`
mutation orderNewCard($id: ID) {
    orderNewCard(id: $id) {
    id
  }
}
`;

export default orderNewCard;



// WEBPACK FOOTER //
// ./src/app/mutations/orderNewCard.js